import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 44 44",
    class: "icon-fi icon-fi-waterproof"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createElementVNode("g", { class: "" }, [
      _createElementVNode("path", {
        d: "M22,10.8c-0.6,1.5-2.6,4.3-4.9,4.3c-1.4,0-2.7-0.4-3.6-1c0,0.3-0.1,0.6-0.1,0.8c-0.2,1.1-0.2,2.2-0.2,3.4\n\t\tc0,8.2,8.9,14.8,8.9,14.8s8.9-6.6,8.9-14.8c0-1.2-0.1-2.3-0.2-3.4c0-0.3-0.1-0.5-0.1-0.8c-0.9,0.6-2.2,1-3.6,1\n\t\tC24.6,15.2,22.6,12.3,22,10.8z",
        class: "icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
      }),
      _createElementVNode("path", {
        d: "M21.9,15.8c0.6,0.9,2.1,3.4,2.9,4.9c1,1.7,1.5,3.5,0.6,5l0,0c-0.1,0.2-0.3,0.5-0.5,0.7\n\t\tc-0.8,0.8-1.8,1.2-2.8,1.2c-1,0-2.1-0.4-2.9-1.1c-0.2-0.2-0.4-0.4-0.5-0.7l0,0c-0.9-1.5-0.4-3.3,0.5-5\n\t\tC19.9,19.2,21.3,16.7,21.9,15.8z",
        class: "icon-fi--no-fill icon-fi--with-stroke"
      }),
      _createElementVNode("path", {
        d: "M20.7,21.3c-0.7,1.4-1.3,2.6-0.4,3.9",
        class: "icon-fi--stroke-linecap-round icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
      })
    ], -1)
  ]), 16))
}
export default { render: render }